import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Icon1 from "../../images/app2.png";
import Icon3 from "../../images/app4.png";
import { NavLink } from "react-router-dom";

// =============================================
// ExploreTechnologyBanner Component
// =============================================
// This component displays a banner section showcasing different technology apps 
// available in the ecosystem. Each app is represented by an image, title, 
// and navigation link. The section is structured using Material-UI Grid 
// for responsive layout.

export default function ExploreTechnologyBanner() {
  // Array of technology apps with navigation links, images, and titles.
  const apps = [
    {
      href: "/partner-app", // Navigation link for Partner App
      image: Icon3, // Icon image for the app
      title: "Installer App", // Title displayed below the icon
    },
    {
      href: "/edge-ai-super-app", // Navigation link for Edge AI Super App
      image: Icon3,
      title: "DTN/Edge AI Super App",
    },
    {
      href: "/abn-app", // Navigation link for ABN App
      image: Icon1,
      title: "ABN App",
    },
    {
      href: "/agriminer-app", // Navigation link for AgriMiner App
      image: Icon3,
      title: "AgriMiner App",
    },
  ];

  return (
    // Main container for the technology banner section
    <div maxwidth={12} className="businessPartnerContainer agristackContainer">
      <Container maxWidth="sm" className="gridSection gridSection--mod">
        {/* Grid layout for displaying app cards */}
        <Grid 
          container={true} 
          alignItems="center"  
          justifyContent="center"
          spacing={1} 
          direction="row"
        >
          {/* Mapping through the apps array to generate app cards dynamically */}
          {apps.map((e, index) => {
            return (
              <Grid
                key={index} // Unique key for each Grid item
                id="ecoSystemView_link"
                className="hoverEffect mb-3"
                item
                md={3} // Medium screen size: 3 columns
                sm={4} // Small screen size: 4 columns
                xs={6} // Extra small screen size: 6 columns
              >
                {/* Navigation link to the respective app page */}
                <NavLink to={e.href}>
                  <img src={e.image} alt="ecoSystem & Mobile Apps View" />
                  <h4>{e.title}</h4> {/* Display app title */}
                </NavLink>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
}
